<template>
    <div class="ku-tool-profit">
        <div class="word">
            <span>餐饮净利润预估表</span>
            <span>餐饮盈亏平衡点表</span>
        </div>

        <van-row class="content">
            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.turnover" label="预估营业额" class="s0">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="8">
                <van-field v-model.trim="row.ingredients" label="食材" readonly class="s1">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="4">
                <van-field type="number" @input="onPrice" v-model.trim="row.bfb" class="s2">
                    <template class="right-1" #right-icon>
                        <span>%</span>
                    </template>
                </van-field>
            </van-col>

            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.rent" label="房租">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.property_fee" label="物业费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>

            <van-col span="24"></van-col>
            <van-col span="24"></van-col>

            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.wage" label="工资">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.water_fee" label="水费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>

            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.bonus" label="奖金">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.electricity_bill" label="电费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>

            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.dormitory" label="宿舍">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.gas_fee" label="燃气费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>

            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.trash_fee" label="垃圾费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.packing_fee" label="包材费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>

            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.marketing_fee" label="营销费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.software_fee" label="软件费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>

            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.maintenance_fee" label="维修费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.network_fee" label="网络费">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>

            <van-col span="12">
                <van-field type="number" @input="onPrice" v-model.trim="row.staff_meal" label="员工餐">
                    <template class="right-1" #right-icon>
                        <span>元</span>
                    </template>
                </van-field>
            </van-col>
            <van-col span="12"><van-field type="number" @input="onPrice" v-model.trim="row.office_fee" label="办公及杂费" class="s0">
                <template class="right-1" #right-icon>
                    <span>元</span>
                </template>
            </van-field>
            </van-col>

        </van-row>

        <div class="fee">
            <span>预计净利润：￥ {{ row.fee }}元/{{ row.fee_bfb }}%</span>
            <span>盈亏平衡点：￥ {{ row.loss }}元</span>
        </div>

    </div>
</template>

<script>

import Vue from 'vue';
import {Field, Col, Row, Button} from 'vant';
import {setCookie} from "@/utils/auth";

Vue.use(Field).use(Col).use(Row).use(Button);

export default {
    name: "Profit",
    data() {
        return {
            row: {
                turnover: '',
                ingredients: '', // 食材成本
                bfb: 30,
                rent: '',
                property_fee: '',
                wage: '',
                water_fee: '',
                bonus: '',
                electricity_bill: '',
                dormitory: '',
                gas_fee: '',
                trash_fee: '',
                packing_fee: '',
                marketing_fee: '',
                software_fee: '',
                maintenance_fee: '',
                network_fee: '',
                staff_meal: '',
                office_fee: '',

                fee: 0,  // 利润
                fee_bfb: 0,  // 利润
                cost: 0, // 成本
                loss: 0, // 盈亏
            }
        }
    },
    mounted() {
    },
    methods: {
        onPrice: function () {
            let ve = this

            ve.row.cost = 0
            if (ve.row.rent) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.rent);
            }
            if (ve.row.property_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.property_fee);
            }
            if (ve.row.wage) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.wage);
            }
            if (ve.row.water_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.water_fee);
            }
            if (ve.row.bonus) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.bonus);
            }
            if (ve.row.electricity_bill) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.electricity_bill);
            }
            if (ve.row.dormitory) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.dormitory);
            }
            if (ve.row.gas_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.gas_fee);
            }
            if (ve.row.trash_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.trash_fee);
            }
            if (ve.row.packing_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.packing_fee);
            }
            if (ve.row.marketing_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.marketing_fee);
            }
            if (ve.row.software_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.software_fee);
            }
            if (ve.row.maintenance_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.maintenance_fee);
            }
            if (ve.row.network_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.network_fee);
            }
            if (ve.row.staff_meal) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.staff_meal);
            }
            if (ve.row.office_fee) {
                ve.row.cost = ve.$number.numberPlus(ve.row.cost, ve.row.office_fee);
            }

            if (ve.row.turnover) {
                ve.row.fee = ve.row.turnover
                if (ve.row.bfb) {
                    ve.row.ingredients = ve.$number.numberRide(ve.row.turnover, ve.$number.numberExcept(ve.row.bfb, 100));
                    ve.row.fee = ve.$number.numberReduce(ve.row.fee, ve.row.ingredients);
                }

                ve.row.fee = ve.$number.numberReduce(ve.row.fee, ve.row.cost);
                ve.row.fee_bfb = ve.$number.numberExcept(ve.row.fee, ve.row.turnover).toFixed(2);
                ve.row.fee_bfb = ve.$number.numberRide(ve.row.fee_bfb, 100);

            } else {
                ve.row.fee = 0
                ve.row.fee_bfb = 0
            }

            // cost + (cost/(1-bfb)*bfb)
            let a = ve.$number.numberExcept(ve.row.bfb, 100);
            let b = ve.$number.numberReduce(1, ve.$number.numberExcept(ve.row.bfb, 100));
            let c = ve.$number.numberExcept(ve.row.cost, b)
            let d = ve.$number.numberRide(c, a)
            ve.row.loss = ve.$number.numberPlus(ve.row.cost, d).toFixed(2)

            setCookie('tool_profit', JSON.stringify(ve.row));

        }
    },
}
</script>

<style scoped lang="less">
@import "/src/styles/base.less";
.ku-tool-profit {
    min-height: 100%;
    background: @green1;
    padding-bottom: 20px;
    .word {
        font-size: 55px;
        color: #fff;
        line-height: 60px;
        padding: 50px 0;
        span {
            display: block;
        }
    }
    .content {
        width: 720px;
        margin: 0 auto;
        .van-col {
            padding: 5px 5px;
            .van-field {
                border-radius: 12px;
                /deep/ .van-cell__title {
                    width: 100px;
                }
            }
            .s0 {
                /deep/ .van-cell__title {
                    width: 140px;
                }
            }
            .s1 {
                /deep/ .van-cell__title {
                    width: 60px;
                }
            }
            .s2 {
                padding-right: 15px;
                padding-left: 15px;
                /deep/ .van-field__right-icon {
                    padding-left: 0;
                }
            }
        }
    }
    .fee {
        width: 750px;
        margin: 0 auto;
        span {
            display: block;
            width: 80%;
            height: 60px;
            line-height: 60px;
            color: @orange;
            font-size: 30px;
            border: 1px solid #fff;
            border-radius: 20px;
            margin: 10px auto;
        }
    }
}
</style>
